import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import sirionPhoto from '../../assets/img/sirion.png'

export default function HeadLine(){
  const [greeting,setGreeting] = useState("Hi, I'm");

  useEffect(()=>{
    const hour = new Date().getHours();
    let greet = "Good Morning, I'm"
    if(hour > 17){
      greet = "Good Evening, I'm"
    }else if(hour > 11){
      greet = "Good Afternoon, I'm"
    }
    setGreeting(greet)
  },[])

  return (
    <Container id="top">
      <HeroContent className="container">
        <GreetingContainer>
          <GreetingHeadline>{greeting}</GreetingHeadline>
          <DisplayName>Sirion Vittayakorn</DisplayName>
          <Paragraph>
            My research interests lie at the intersection of artificial intelligence, educational technology, and interactive systems. My work focuses on applying machine learning, computer vision, natural language processing, game-based learning, and immersive technologies to develop practical solutions for education, communication, and real-world decision-making.
          </Paragraph>
        </GreetingContainer>
        <PortraitWrapper>
          <DisplayImage src={sirionPhoto} alt="Portrait of Sirion Vittayakorn" />
        </PortraitWrapper>
      </HeroContent>
    </Container>
  );
}

const Container = styled.section`
  overflow: hidden;
  min-height: 500px;
  display: flex;
  align-items: stretch;

  @media (max-width: 767px) {
    min-height: auto;
    padding-top: 32px;
  }
`

const HeroContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(240px, 1fr);
  gap: clamp(16px, 4vw, 56px);
  align-items: end;
  width: 100%;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 8px;
    text-align: center;
  }
`

const PortraitWrapper = styled.div`
  align-self: end;
  display: flex;
  justify-content: center;
  min-width: 0;
`

const DisplayImage = styled.img`
  display: block;
  width: min(100%, 380px);
  height: auto;
  max-height: 500px;
  object-fit: contain;
  object-position: bottom center;
  transform: translateY(10%);
  z-index: -1;

  @media (max-width: 767px) {
    width: min(78vw, 340px);
    max-height: 390px;
    transform: none;
  }
`

const GreetingContainer = styled.div`
  margin-bottom: clamp(24px, 5vw, 56px);
  align-self: end;
  min-width: 0;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`

const GreetingHeadline = styled.h2`
  color: var(--assent-color);
  font-weight: 400;
  font-family: 'Concert One', cursive;
  text-align: right;
  font-size: clamp(1.5rem, 4vw, 2rem);

  @media (max-width: 767px) {
    text-align: center;
  }
`

const DisplayName = styled.h1`
  color: var(--assent-color);
  font-weight: 400;
  font-family: 'Concert One', cursive;
  text-align: right;
  font-size: clamp(2.25rem, 6vw, 4.25rem);
  line-height: 1.05;

  @media (max-width: 767px) {
    text-align: center;
  }
`

const Paragraph = styled.p`
  font-size: clamp(1rem, 2vw, 1.3rem);
  color: var(--text-color);
  text-align: right;
  max-width: 760px;
  margin-left: auto;

  @media (max-width: 767px) {
    text-align: center;
    margin: 16px auto 0;
    max-width: 42rem;
  }
`
